import script from "./CheckboxInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./CheckboxInput.vue?vue&type=script&setup=true&lang=ts"

import "./CheckboxInput.vue?vue&type=style&index=0&id=108182d4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-108182d4"]])

export default __exports__